export default __webpack_public_path__ + "static/media/icon-budgeting.ad716997.svg";